import { EditReason } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipActions/EditReason';
import { MoreChartActionsButton } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipActions/MoreChartActionsButton';
import { useChartTooltipStore } from '@modules/charts/components/ChartTooltipWrapper/hooks';
import { Box, Divider, List } from '@mui/material';
import { FieldNames } from 'v2/core/entities/fields';
import { AddToFilter } from './AddToFilter';
import { MergeWithAnotherReason } from './MergeWithAnotherReason';
import { ViewFeedback } from './ViewFeedback';

interface ChartTooltipActionsProps {
  shouldHideReasonActions?: boolean;
}

export function ChartTooltipActions({
  shouldHideReasonActions = false,
}: ChartTooltipActionsProps) {
  const fieldName = useChartTooltipStore(({ fieldName }) => fieldName);

  const shouldShowReasonActions =
    fieldName === FieldNames.Reason && !shouldHideReasonActions;

  return (
    <List dense disablePadding sx={{ pb: 0.5 }}>
      <Divider component="li" />
      <AddToFilter />
      <ViewFeedback />
      {shouldShowReasonActions && (
        <Box>
          <Divider component="li" />
          <MoreChartActionsButton>
            <Box py={0.5}>
              <MergeWithAnotherReason />
              <EditReason />
            </Box>
          </MoreChartActionsButton>
        </Box>
      )}
    </List>
  );
}
